export const SHA_256 = "SHA-256";
export const S256 = "S256";
export const BCBS = "bcbs";
export const REACT_PUBLIC_CONSENT_CLIENT_ID = "OAuth-MMA_Consent_APP00046856";
export const languageKey = {
  en: "english",
  es: "spanish",
};
export const trustedDevices = "trusted-devices";
export const securityCenter = "security-center";
export const consent_management = "consent-management";
export const pathKey = "path";
export const accessTokenFetchFailed = "accessTokenFetchFailed";
export const trustedDevicesFetchFail = "trustedDevicesFetchFail";
export const trustedDevicesDeleteFail = "trustedDevicesDeleteFail";
export const authorizeMFAService = "hcsc-members-mma-mfa";
export const authorizePasswordlessService = "HCSC_Passwordless_Auth_BCBSXX";
export const passKeyFetchFail = "passKeyFetchFail";
export const passKeyAddorDeleteFail = "passKeyAddOrDeleteFail";
export const defaultTrustedDeviceNameFromCIDM = "TrustedDevice";
export const consentOAuthScopes = "openid hcscconsentscope profile ";
export const consentOAuthScopesExtended = "openid hcscconsentscope profile hcsc_access";

export const requestOptions = {
  method: "GET",
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
  credentials: "include" as RequestCredentials,
  redirect: "manual" as RequestRedirect,
};
